import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { FormBuilder,FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-milestone',
  standalone:false,
  templateUrl: './milestone.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class MilestoneComponent implements OnInit, OnChanges{

  @Input() stepDetails: any;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() proposalName:String;
  isDocumentUploadsOpen=false
    mileStoneForm:FormGroup
  selectedVendor: string | null = null;
  isUploadFormOpen: boolean = false;
  baseUrl = environment.APIUrl
  constructor( private messageService: MessageService,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private api: ApiService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef){
      this.mileStoneForm = this.fb.group({
      technical_phase: [false],
      financial_phase: [false],
      disbursed_amount: [0],
      actual_date: [''],
      wbs_date: [''],
      wbs_amount: [0]
      });
    }


  ngOnChanges(changes: SimpleChanges): void {
    if(changes['stepDetails']){
      this.getmilestoneData()
    }
  }

  ngOnInit(): void {
    // this.getmilestoneData()
    this.initializeWbsUpload();
  }

  apiData: any = {};
  vendorNames: any[] = [];

  //  add new version 
  vendorWbsData: any = {};   // store table per vendor
data: any[] = [];
isNewVersionAdded = false;

toggleVersion() {
  this.isNewVersionAdded ? this.removeNewVersion() : this.addVersion();
}

addVersion() {

  this.data.forEach((row: any) => {

    if (!row.versions) {
      row.versions = [];
    }
    row.versions.forEach((v: any) => v.isEditable = false);

    row.versions.push({
      version: row.versions.length + 1,
      subtask: '',
      duration: '',
      start: '',
      end: '',
      isEditable: true
    });

  });

  this.isNewVersionAdded = true;
  this.data = [...this.data];
}

removeNewVersion() {

  this.data.forEach((row: any) => {
    if (row.versions?.length) {
      row.versions.pop();
    }
  });

  this.isNewVersionAdded = false;
  this.data = [...this.data];
}

saveVersions() {

  const wbs_sheet: any[] = [];

  this.data.forEach((row: any, index: number) => {

    if (!row.versions?.length) return;

    // ✅ GET ONLY LAST VERSION (NEW ONE)
    const latestVersion = row.versions[row.versions.length - 1];

    // ✅ Skip if empty
    if (!latestVersion?.subtask && !latestVersion?.duration && !latestVersion?.start && !latestVersion?.end) return;

    wbs_sheet.push({
      row_number: String(index + 1),

      subtask: latestVersion.subtask,
      duration_week: latestVersion.duration,

      start_date: latestVersion.start ? this.formatDate(latestVersion.start) : null,
      end_date: latestVersion.end ? this.formatDate(latestVersion.end) : null
    });

  });

  if (!wbs_sheet.length) {
    console.warn('No new data to save');
    return;
  }

  const payload = {
    proposal_id: this.stepDetails.proposal,
    vendor_id: this.vendorIds[this.selectedVendor!],
    wbs_sheet
  };

  console.log('FINAL PAYLOAD:', payload);

  this.apiService.postAPI(`/idex/wbs/milestone/version/`, payload)
    .subscribe(() => {

      this.messageService.add({
        severity: 'success',
        summary: 'Saved',
        detail: 'New version saved successfully'
      });

       this.data.forEach((row: any) => {
      row.versions.forEach((v: any) => v.isEditable = false);
    });

    this.isNewVersionAdded = false;
    this.isVersionLocked = true;

    this.cdr.markForCheck();

      this.isVersionLocked = true;

    });
}

formatDate(date: any): string {
  const d = new Date(date);

  const year = d.getFullYear();
  const month = ('0' + (d.getMonth() + 1)).slice(-2);
  const day = ('0' + d.getDate()).slice(-2);

  return `${year}-${month}-${day}`;
}
selectedVendorId:any;
proposalId:any;
isVersionLocked:boolean = false;
vendorIds:any;


/* ================= GET DATA ================= */
getmilestoneData() {

  if (!this.stepDetails) return;

  this.apiService
    .getAPI(`/idex/step/milestone/details/?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}&milestone_code=${this.stepDetails.code}`)
    .subscribe((res: any) => {

      this.apiData = res.vendors || {};
      this.vendorNames = Object.keys(this.apiData);

      this.vendorWbsData = {};
      this.vendorIds = {};

      this.vendorNames.forEach((vendorName: string) => {

        const vendorObj = this.apiData[vendorName]?.[0];

        // ✅ store vendor id
        // this.vendorIds[vendorName] = vendorObj?.id;
        this.vendorIds[vendorName] = vendorObj?.vendor?.id;


        const milestoneData = vendorObj?.milestone_data || [];

        // ✅ transform correctly
        this.vendorWbsData[vendorName] = this.transformMilestones(milestoneData);
        

      });

      // ✅ default select first vendor
      this.selectedVendor = this.vendorNames[0];
      this.data = this.vendorWbsData[this.selectedVendor] || [];

      this.cdr.markForCheck();

    });
}
transformMilestones(milestoneData: any[]) {

  const rowMap: any = {};

  milestoneData.forEach((versionBlock: any) => {

    const version = versionBlock.version;

    (versionBlock.milestones || []).forEach((m: any) => {

      const rowKey = m.row_number;

      if (!rowMap[rowKey]) {
        rowMap[rowKey] = {
          milestone: m.title || '',
          deliverable: m.deliverable || '',
          subDeliverable: m.sub_deliverable || '',
          majorTask: m.major_task || '',
          versions: []
        };
      }

      rowMap[rowKey].versions.push({
        version: version,
        subtask: m.subtask || '',
        duration: m.duration_week || '',
        start: m.start_date || '',
        end: m.end_date || '',
        isEditable: false
      });

    });

  });

  // ✅ sort versions
  Object.values(rowMap).forEach((row: any) => {
    row.versions.sort((a: any, b: any) => a.version - b.version);
  });

  return Object.values(rowMap);
}
  onSubmit(){
    console.log(this.apiData,this.vendorNames);
    this.vendorNames.forEach(vendorName=>{
      console.log(this.apiData[vendorName][0]);
      let payload={
        id:this.apiData[vendorName][0]?.id,
        technical_phase:this.apiData[vendorName][0].technical_phase,
        financial_phase:this.apiData[vendorName][0].financial_phase,
        disbursed_amount:this.apiData[vendorName][0].disbursed_amount,
        actual_date:this.apiData[vendorName][0].actual_date,
        wbs_date:this.apiData[vendorName][0].wbs_date,
        wbs_amount:this.apiData[vendorName][0].wbs_amount
      }
      this.apiService.putAPI(`/idex/vendor/milestone/update/${payload.id}/`,payload).subscribe((res:any)=>{
      });
    })
    
    
    this.messageService.add({severity:'success',summary:'Success',detail:'Milestone updated successfully'});
  this.getmilestoneData()
    
  }
  generatePDF(){
    
  }
  lableBoject={
    'MS00':'Upload Supporting Documents',
    'MS01':'Upload Supporting Documents',
    'MS02':'Upload Supporting Documents',
    'MS03':'Upload Trial directives, PSQR & Supporting Documents',
    'MS04':'Upload Supporting Documents',
    'MS05':'Upload Supporting Documents',
    
  }
  formData:any={}
onVendorChange(vendorName: string) {

  this.selectedVendor = vendorName;

  this.data = this.vendorWbsData[vendorName] || [];

  this.isNewVersionAdded = false;

  this.cdr.markForCheck();
}
get maxVersions(): number {
  return Math.max(...this.data.map(r => r.versions?.length || 0), 0);
}



  /* ---------- WBS Upload ---------- */

isWbsUploadOpen = false;
wbsUploadForm!: FormGroup;
selectedWbsFile: File | null = null;

initializeWbsUpload() {
  this.wbsUploadForm = this.fb.group({
    wbs_file: [null]
  });
}

toggleWbsUpload() {
  this.isWbsUploadOpen = !this.isWbsUploadOpen;
}

onWbsFileSelected(event: any) {
  const file = event.target.files[0];

  if (file) {
    this.selectedWbsFile = file;
    this.wbsUploadForm.patchValue({ wbs_file: file });

    // ✅ Log uploaded document
    console.log('Uploaded WBS Document:', file);
  }
}
isSubmitting: boolean = false;
submitWbsUpload() {
  if (!this.selectedWbsFile) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Warning',
      detail: 'Please select a WBS file'
    });
    return;
  }

  this.isSubmitting = true;

  const formData = new FormData();
  formData.append('wbs_file', this.selectedWbsFile);
  formData.append('proposal_step', this.stepDetails?.id);

  console.log('Submitting WBS:', this.selectedWbsFile);

  // 🔥 Call API
  this.apiService.postAPI(`/idex/wbs/upload/`, formData).subscribe({
    next: () => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'WBS uploaded successfully'
      });

      this.resetWbsUpload();
    },
    error: () => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Upload failed'
      });
    }
  });
}

resetWbsUpload() {
  this.selectedWbsFile = null;
  this.wbsUploadForm.reset();
  this.isSubmitting = false;
  this.cdr.markForCheck();
}


 /* ================= FORM ================= */
  sparkForms: FormGroup = new FormGroup({
    spark_grant_approve: new FormControl('', Validators.required),
    matching_contribution: new FormControl('', Validators.required),
    start_date: new FormControl('', Validators.required),
    end_date: new FormControl('', Validators.required),
    sign_document: new FormControl(null)
  });

  /* ================= TABLE ================= */
  vendorTabs: any[] = [];
  activeVendorIndex = 0;
  isEditMode = false;

  /* FIXED COLUMN */
  tableColumn: string[] = [
    'Milestone',
    'Deliverables Guideline',
    'Sub-Deliverables',
    'Major Tasks',
    'Subtasks',
    'Duration(weeks)',
    'Start Date',
    'End Date'
  ];
  getFileName(path: string | null | undefined): string {
    if (!path) return '';
    return path.split('/').pop() || '';
  }


  /* ================= BUILD TABS ================= */
  buildVendorTabs(res: any) {

    const vendorMap = res?.vendors || {};

    this.vendorTabs = Object.keys(vendorMap).map((name: any, index: number) => {

      const vendorObj = vendorMap[name] || {};

      /* 🔥 Spark Grant ID */
      const sparkId = vendorObj?.id ?? null;

      /* 🔥 Vendor ID */
      const vendorId = vendorObj?.vendor?.id ?? null;

      /* ===== GRANT DATA ===== */
      const grant = {
        id: sparkId,
        spark_grant_approve: vendorObj?.spark_grant_approve ?? '',
        matching_contribution: vendorObj?.matching_contribution ?? '',
        start_date: vendorObj?.start_date ?? '',
        end_date: vendorObj?.end_date ?? '',
        sign_document: vendorObj?.sign_document ?? null
      };

      /* 🔥 Patch first vendor */
      if (index === 0) {
        this.sparkForms.patchValue({
          spark_grant_approve: grant.spark_grant_approve,
          matching_contribution: grant.matching_contribution,
          start_date: grant.start_date,
          end_date: grant.end_date
        });

        this.sparkForms.get('sign_document')?.setValue(null);
      }

      /* ===== TABLE DATA ===== */
      let data: any[] = [];

      if (vendorObj?.milestone?.length) {

        data = vendorObj.milestone.map((item: any) => ({
          'Milestone': item?.title ?? '',
          'Deliverables Guideline': item?.deliverable ?? '',
          'Sub-Deliverables': item?.sub_deliverable ?? '',
          'Major Tasks': item?.major_task ?? '',
          'Subtasks': item?.subtask ?? '',
          'Duration(weeks)': item?.duration_week ?? '',
          'Start Date': item?.start_date ?? '',
          'End Date': item?.end_date ?? '',
        }));

      } else {
        // data = this.createBlankRows();
      }

      return {
        label: `Vendor ${index + 1}`,
        name,
        sparkId,   // ✅ spark grant id
        vendorId,  // ✅ vendor id
        data,
        grant
      };

    });

    this.activeVendorIndex = 0;

    console.log('✅ Vendor Tabs:', this.vendorTabs);
  }





  /* ================= TAB CHANGE ================= */
  changeVendorTab(index: number) {

    this.activeVendorIndex = index;

    const grant = this.vendorTabs[index]?.grant || {};

    this.sparkForms.patchValue({
      spark_grant_approve: grant.spark_grant_approve ?? '',
      matching_contribution: grant.matching_contribution ?? '',
      start_date: grant.start_date ?? '',
      end_date: grant.end_date ?? '',
    });

    this.sparkForms.get('sign_document')?.setValue(null);
  }


  /* ================= EDIT ================= */
  enableEdit() {
    this.isEditMode = true;
  }


  /* ================= FILE ================= */
  onGrantFileChange(event: any) {

    const file = event.target?.files?.[0];
    if (!file) return;

    this.sparkForms.patchValue({
      sign_document: file
    });

    console.log('📁 File Selected:', file);
  }


  /* ================= SAVE ================= */
  saveVendorData() {

    const activeTab = this.vendorTabs[this.activeVendorIndex];
    const formValue = this.sparkForms.value;

    /* ===== SAFE ID CHECK ===== */
    if (!activeTab?.sparkId && !activeTab?.vendorId) {
      console.error('Missing Spark or Vendor ID');
      return;
    }

    /* ===== REMOVE EMPTY ROW ===== */
    const validRows = activeTab.data.filter((row: any) =>
      Object.values(row).some(v => v)
    );

    /* ===== WBS TABLE ===== */
    const wbsRows = validRows.map((row: any, index: number) => ({
      row_number: index + 1,
      Milestone: row['Milestone'] ?? '',
      'Deliverables Guideline': row['Deliverables Guideline'] ?? '',
      'Sub-Deliverables': row['Sub-Deliverables'] ?? '',
      'Major Tasks': row['Major Tasks'] ?? '',
      Subtasks: row['Subtasks'] ?? '',
      'Duration(weeks)': row['Duration(weeks)'] ?? '',
      'Start Date': row['Start Date'] ?? '',
      'End Date': row['End Date'] ?? '',
    }));

    /* ===== FormData ===== */
    const formData = new FormData();

    /* 🔥 IMPORTANT: Send spark id */
    // if (activeTab.sparkId) {
    //   formData.append('id', activeTab.sparkId.toString());
    // }

    /* 🔥 Vendor */
    if (activeTab.sparkId) {
      formData.append('vendor_id', activeTab.sparkId.toString());
    }
    /* 🔥 File */
    if (formValue.sign_document instanceof File) {
      formData.append('sign_document', formValue.sign_document);
    } else {
      const oldFile = activeTab?.grant?.sign_document;
      if (oldFile) {
        formData.append('sign_document', oldFile);
      }
    }

    /* 🔥 Grant Fields */
    formData.append('spark_grant_approve', formValue.spark_grant_approve ?? '0.00');
    formData.append('matching_contribution', formValue.matching_contribution ?? '0.00');
    formData.append('start_date', formValue.start_date ?? '');
    formData.append('end_date', formValue.end_date ?? '');

    /* 🔥 File */
    if (formValue.sign_document instanceof File) {
      formData.append('sign_document', formValue.sign_document);
    }

    /* 🔥 WBS */
    formData.append('wbs_sheet', JSON.stringify(wbsRows));

    /* ===== DEBUG ===== */
    console.log('🔥 FINAL FORM DATA');
    formData.forEach((v, k) => console.log(k, v));

    /* ===== API ===== */
    this.api.putAPI(`/idex/spark/grant/`, formData)
      .subscribe(() => {

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Vendor data saved successfully',
        });

        this.isEditMode = false;
        
      });

  }
  sparkData: any;
   milestones: any[] = [];
  getSparkDetails() {
    this.api.getAPI(`/idex/spark/grant/?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`)
      .subscribe((res: any) => {
        if (res) {
          this.sparkData = res;
          this.milestones = res.milestone_data;
          this.sparkForms.patchValue({
            challenge_title: res.challenge_title,
            category: res.category,
            development_budget: res.data.development_budget,
            start_date: res.data.start_date,
            end_date: res.data.end_date,
            id: res.data.id,
          });
          this.buildVendorTabs(res)
        }
      });
  }


isVersionFormVisible=false;

currentVersion=2;

versionForm:any={
subtask:'',
duration:'',
start:'',
end:''
};





cancelVersion(){
this.resetForm();
}

resetForm(){

this.isVersionFormVisible=false;

this.versionForm={
subtask:'',
duration:'',
start:'',
end:''
};

}
showVendorForm = false;
toggleVendorForm(){

  this.showVendorForm = !this.showVendorForm;

}

}
